export function selectingTireOptions() {
    const tiresSearchData = window.tires_search ? window.tires_search : null;

    document.addEventListener('DOMContentLoaded', function () {
        if (document.querySelectorAll('.blockTiresSearch')) {
            const tiresSearchBlocks = document.querySelectorAll('.blockTiresSearch');

            if (tiresSearchBlocks) {

                const getSelectedOption = (select) => {
                    return Object.values(select.options).filter(option => {
                        return option.selected;
                    })[0] ?? 'none';
                }

                tiresSearchBlocks.forEach(search => {
                    const typeSelect = search.querySelector('.tire-type');
                    const widthSelect = search.querySelector('.tire-width');
                    const profileSelect = search.querySelector('.tire-profile');
                    const profileEmpty = search.querySelector('.profile-empty');
                    const radiusSelect = search.querySelector('.tire-radius');
                    const searchBtn = search.querySelector('.blockTiresSearch__btn');

                    typeSelect.addEventListener('change', (event) => {
                        const selectedCatSlug = typeSelect.options[event.target.selectedIndex].getAttribute('data-cat-slug');

                        widthSelect.value = 'none';
                        profileSelect.disabled = true;
                        profileSelect.value = 'none';
                        radiusSelect.disabled = true;
                        radiusSelect.value = 'none';

                        profileSelect.style.display = 'block';
                        profileEmpty.classList.remove('active');

                        for (let i = 1; i < widthSelect.options.length; i++) {
                            const option = widthSelect.options[i];

                            if (option.getAttribute('data-cat-slug') === selectedCatSlug) {
                                option.classList.remove('option-hidden');
                            } else {
                                option.classList.add('option-hidden');
                            }
                        }

                        if (Object.keys(tiresSearchData[selectedCatSlug]).length > 0) {
                            widthSelect.disabled = false;
                            searchBtn.disabled = true;
                        } else {
                            widthSelect.disabled = true;
                            searchBtn.disabled = false;
                        }
                    });

                    widthSelect.addEventListener('change', (event) => {
                        profileSelect.value = 'none';
                        radiusSelect.disabled = true;
                        radiusSelect.value = 'none';

                        if (widthSelect.value === 'none') {
                            profileSelect.disabled = true;
                            searchBtn.disabled = true;

                            return;
                        }

                        const selectedCatSlug = getSelectedOption(typeSelect).getAttribute('data-cat-slug');
                        const selectedWidth = event.target.value;

                        let profileCounter = 0;
                        for (let i = 1; i < profileSelect.options.length; i++) {
                            const option = profileSelect.options[i];

                            if (option.getAttribute('data-cat-slug') === selectedCatSlug && option.getAttribute('data-width') === selectedWidth) {
                                option.classList.remove('option-hidden');
                                profileCounter++;
                            } else {
                                option.classList.add('option-hidden');
                            }
                        }

                        profileSelect.style.display = 'block';
                        profileEmpty.classList.remove('active');
                        if(profileCounter <= 1){
                            const _profile = profileSelect.querySelectorAll('option:not(.option-hidden)')[1];
                            if(_profile.text === '–') {
                                profileSelect.value = _profile.value;
                                profileSelect.style.display = 'none';
                                profileEmpty.classList.add('active');
                                profileSelect.dispatchEvent(new Event('change'));
                            }
                        }

                        if (Object.keys(tiresSearchData[selectedCatSlug][selectedWidth]).length > 0) {
                            profileSelect.disabled = false;
                            searchBtn.disabled = true;
                        } else {
                            profileSelect.disabled = true;
                            searchBtn.disabled = false;
                        }
                    });

                    profileSelect.addEventListener('change', (event) => {
                        radiusSelect.value = 'none';

                        if (profileSelect.value === 'none') {
                            radiusSelect.disabled = true;
                            searchBtn.disabled = true;

                            return;
                        }

                        const selectedCatSlug = getSelectedOption(typeSelect).getAttribute('data-cat-slug');
                        const selectedWidth = getSelectedOption(widthSelect).value;
                        const selectedProfile = event.target.value;

                        for (let i = 1; i < radiusSelect.options.length; i++) {
                            const option = radiusSelect.options[i];

                            if (option.getAttribute('data-cat-slug') === selectedCatSlug && option.getAttribute('data-width') === selectedWidth && option.getAttribute('data-profile') === selectedProfile) {
                                option.classList.remove('option-hidden');
                            } else {
                                option.classList.add('option-hidden');
                            }
                        }

                        if (Object.keys(tiresSearchData[selectedCatSlug][selectedWidth][selectedProfile]).length > 0) {
                            radiusSelect.disabled = false;
                            searchBtn.disabled = true;
                        } else {
                            radiusSelect.disabled = true;
                            searchBtn.disabled = false;
                        }
                    });

                    radiusSelect.addEventListener('change', (event) => {
                        searchBtn.disabled = radiusSelect.value === 'none';
                    });
                });
            }
        }
    })
}

export function initTireSearch() {
    document.addEventListener('DOMContentLoaded', function () {
        if (document.querySelectorAll('.blockTiresSearch')) {
            const tiresSearchBlocks = document.querySelectorAll('.blockTiresSearch');

            if (tiresSearchBlocks) {
                tiresSearchBlocks.forEach(search => {
                    const searchBtn = search.querySelector('.blockTiresSearch__btn');

                    if (searchBtn && !searchBtn.disabled) {
                        searchBtn.addEventListener('click', function () {
                            const typeValue = search.querySelector('.tire-type').value;
                            const widthValue = search.querySelector('.tire-width').value;
                            const profileValue = search.querySelector('.tire-profile').value;
                            const radiusValue = search.querySelector('.tire-radius').value;
                            let link = '';

                            if (typeValue !== 'none' || widthValue !== 'none' || profileValue !== 'none' || radiusValue !== 'none') {
                                if (typeValue !== 'none') {
                                    link = searchBtn.getAttribute('data-home');
                                    link += typeValue;
                                } else {
                                    link = searchBtn.getAttribute('data-shop');
                                }
                                link += '?filters=';
                                if (widthValue !== 'none') link += 'szerokosc-opony[' + widthValue + ']|';
                                if (profileValue !== 'none' && profileValue !== '1565') link += 'profil-opony[' + profileValue + ']|';
                                if (radiusValue !== 'none') link += 'srednica[' + radiusValue + ']|';

                                window.location.href = link;
                            }
                        })
                    }
                });
            }
        }
    })
}